import bootstrap from "shared/bootstrap";
import baseManifest from "modules/base";
import portalManifest from "./portal-manifest";
import envLoader from "shared/env-loader";
import relationprofile from "modules/relationprofile";
import compendalicense from "modules/compendalicense";
import projects from "modules/projects";
import manuals from "modules/manuals";
import feedback from "modules/feedback";
import invoices from "modules/invoices";
import contact from "modules/contact";

const vuetify = {
  theme: {
    primary: "#e98825",
    secondary: "#ed9f50",
    accent: "#bad1e2",
    error: "#f44336",
    warning: "#ffeb3b",
    info: "#2196f3",
    success: "#4caf50"
  }
};

bootstrap({
  title: "Mijn Compenda",
  vuetify,
  modules: [
    baseManifest,
    portalManifest,
    relationprofile,
    compendalicense,
    projects,
    invoices,
    manuals,
    feedback,
    contact
  ],
  axios: {
    baseURL: envLoader("API_URL", "/"),
    withCredentials: true
  },
  customToolbar: [
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    () => import("../../modules/feedback/components/ToolbarFeedbackAction.vue"),
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    () => import("../../modules/contact/components/GlobalContactButton.vue")
  ]
});
